export default {
  simulation: {
    title: {
      en: "Derivation Tree Visualization",
      pt: "Visualização da Árvore de Derivação",
    },
    waiting: {
      en: "Waiting for simulation via HUD...",
      pt: "Aguardando simulação via HUD...",
    },
    wordLabel: {
      en: "Simulated Word",
      pt: "Palavra Simulada",
    },
    emptyWord: {
      en: "λ (Empty Word)",
      pt: "λ (Palavra Vazia)",
    },
  },

  controls: {
    zoomIn: {
      en: "+ Zoom",
      pt: "+ Zoom",
    },
    zoomOut: {
      en: "- Zoom",
      pt: "- Zoom",
    },
    next: {
      en: "Next Step",
      pt: "Próximo Passo",
    },
    previous: {
      en: "Previous",
      pt: "Anterior",
    },
    showAll: {
      en: "Show All",
      pt: "Exibir Tudo",
    },
  },

  tree: {
    start: {
      en: "Start",
      pt: "Início",
    },
    ruleLabel: {
      en: "Rule",
      pt: "Regra",
    },
  },
};
